/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const UpsertBillingScheduleTierOutputJsonApiModel = {
  id: "",
  "billing-schedule-tier": {
    jsonApi: "hasOne",
    type: "billing-schedule-tiers",
  },
  "billing-schedule-tiers": {
    jsonApi: "hasMany",
    type: "billing-schedule-tiers",
  },
};
